import { jssPreset } from '@material-ui/styles';
import { create } from 'jss';
import * as jssIncreaseSpecificity from 'jss-increase-specificity';
import jssAllImportant from 'jss-plugin-all-important';

export const jssPluginsAlpha = create({
  plugins: [
    // isolate({ isolate: "root", reset: "inherited" }),
    // not 'root' because that's used throughout MUI - see https://github.com/cssinjs/jss/issues/326
    ...jssPreset().plugins,
    jssRemToPx(),
    jssAllImportant(),
    jssIncreaseSpecificity(),
  ],
});

export const jssPluginsBudapest = create({
  plugins: [
    // isolate({ isolate: "root", reset: "inherited" }),
    // not 'root' because that's used throughout MUI - see https://github.com/cssinjs/jss/issues/326
    ...jssPreset().plugins,
    jssRemToPx(),
    jssAllImportant(),
  ],
});

/**
 * Replace all css rules with rem to be px
 * Intended to be used when you have no control over the document
 * Takes baseFontSize: number, which is the base font size
 */
export function jssRemToPx(options = { baseFontSize: 16 }) {
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (const prop in style) {
      if (
        style[prop] &&
        style[prop].charAt &&
        style[prop].slice(-3) === 'rem'
      ) {
        style[prop] = convertRemToPx(style[prop], options.baseFontSize);
      }
    }

    return style;
  }

  function onChangeValue(value, _prop, _rule) {
    if (value && value.charAt && value.slice(-3) === 'rem') {
      return convertRemToPx(value, options.baseFontSize);
    }

    return value;
  }

  function convertRemToPx(value, baseFontSize) {
    let newValue = value.slice(0, value.length - 3);
    newValue = newValue * baseFontSize;
    return newValue + 'px';
  }

  return {
    onProcessStyle,
    onChangeValue,
  };
}

/**
 * Replace all css rules with em to be px
 * Intended to be used when you have no control over the document
 * Takes baseFontSize: number, which is the base font size
 */
export function jssEmToPx(options = { baseFontSize: 16 }) {
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (const prop in style) {
      if (style[prop] && style[prop].charAt && style[prop].slice(-2) === 'em') {
        style[prop] = convertEmToPx(style[prop], options.baseFontSize);
      }
    }

    return style;
  }

  function onChangeValue(value, _prop, _rule) {
    if (value && value.charAt && value.slice(-2) === 'em') {
      return convertEmToPx(value, options.baseFontSize);
    }
    return value;
  }

  function convertEmToPx(value, baseFontSize) {
    let newValue = value.slice(0, value.length - 2);
    newValue = newValue * baseFontSize;
    return newValue + 'px';
  }

  return {
    onProcessStyle,
    onChangeValue,
  };
}
